import { createFileRoute } from '@tanstack/react-router';
import { AffiliateTermsPage } from '../../pages/AffiliateTermsPage';
import { staticPageHead } from '../../lib/seo/staticPageHead';

export const Route = createFileRoute('/_site/affiliate-terms')({
  head: () =>
    staticPageHead({
      path: '/affiliate-terms',
      title: 'Affiliate Program Terms - AnyAPI',
      description:
        'The terms governing the AnyAPI Affiliate Program: how referrals are attributed, what earns commission, payout in cash or credit, reversals, and taxes.',
      crumb: 'Affiliate Program Terms',
    }),
  component: AffiliateTermsPage,
});
